import React from "react";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import "./Background.scss"; // Make sure to import your new SCSS file

const Background = () => {
    return (
        <>
            <h2 className="head-text">Background</h2>

            <div className="app__profiles app__profiles--vertical">


                <motion.div
                    whileInView={{ opacity: 1 }}
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.5, type: "tween" }}
                    className="app__profile-item"
                >
                    <p className="p-text">
                        I’ve learned that technology’s greatest potential isn’t only in the systems it builds but in the people it empowers. My work at Epistemic Analytics taught me how carefully designed systems can free researchers from tedious manual data labeling—reducing that burden by 96%—so they can focus on groundbreaking discoveries. These numbers tell a story of technical achievement, but their deeper value lies in the lives they touch: people having the time, tools, and insights to do what matters most.
                    </p>

                    <p className="p-text">
                        The real motivation behind my work lies in the broader impact it serves. From collaborating on an interactive map that helps Harvard researchers visualize humanitarian efforts, to developing a solar dashboard that encourages communities in Wisconsin to invest in renewable energy, I’ve seen how technology can ripple outward to create positive change. I’m also proud of improving trash-detection accuracy by 10% for environmental project and winning first place for developing a Braille-based communication app designed to assist deaf-blind users.
                    </p>

                    <p className="p-text">
                        Every line of code I write stems from a desire to make the world a better place. Computer Science and Data Science allow me to transcend physical borders and address global challenges, creating solutions that ripple outward to improve lives in ways both small and monumental. It is through this work that I hope to contribute meaningfully to a brighter, more hopeful future—one where technology becomes a tool for problem-solving and a catalyst for human progress.

                    </p>
                </motion.div>





            </div>
        </>
    );
};

export default AppWrap(
    MotionWrap(Background, "app__background"),
    "background",
    "app__whitebg"
);
